import { render, staticRenderFns } from "./Profile.Order.Show.vue?vue&type=template&id=ff44d35e&scoped=true"
import script from "./Profile.Order.Show.vue?vue&type=script&lang=js"
export * from "./Profile.Order.Show.vue?vue&type=script&lang=js"
import style0 from "./Profile.Order.Show.vue?vue&type=style&index=0&id=ff44d35e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff44d35e",
  null
  
)

export default component.exports